<template>
    <b-card no-body>
        <entry-header
            :active-chat="activeChat"
            :entry="entry"
            :is-expanded="isExpanded"
            :sender="sender"
            @expanded="setExpanded"
            @load-editor-content="$emit('load-editor-content')"
        />

        <b-card-body
            v-show="isExpanded"
            ref="mailMessageWrapper"
            class="mail-message-wrapper pt-2"
            @click="pointerEventClass = 'pointer-event-auto'"
            @mouseleave="pointerEventClass = 'pointer-event-none'"
        >
            <b-spinner v-if="(!entry.metadata || iframeLoading) && entry.status !== 'declined'" />
            <font-awesome-icon v-else-if="entry.status === 'declined'" icon="times" size="2xl" />

            <iframe
                v-if="entry.metadata && entry.status !== 'declined'"
                ref="iframe"
                :class="pointerEventClass"
                class="mail-message"
                sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                @load="iframeLoading = false"
            />
        </b-card-body>
    </b-card>
</template>

<script>
import { BCard, BCardBody, BSpinner } from "bootstrap-vue";
import EntryHeader from "@/views/modules/email-inbox/active-chat-log-entries/components/entryHeader";
import { ref, onMounted } from "@vue/composition-api";

export default {
    components: {
        BSpinner,
        BCard,
        BCardBody,
        EntryHeader,
    },
    props: {
        activeChat: {
            type: Object,
            required: true,
        },
        entry: {
            type: Object,
            required: true,
        },
        sender: {
            type: Object,
            required: true,
        },
        lastEntryId: {
            type: Number | String, // Strings allowed, be generated uuid
            required: false,
        },
        setIframeProperties: {
            type: Function,
            required: true,
        },
        isSendPending: {
            type: Boolean,
            required: false,
        },
    },
    setup(props) {
        const iframe = ref();
        const iframeLoading = ref(true);
        const mailMessageWrapper = ref();
        const isExpanded = ref(props.entry.id === props.lastEntryId);
        const pointerEventClass = ref("pointer-event-none"); // "pointer-event-none" or "pointer-event-auto"

        onMounted(() => {
            props.setIframeProperties(iframe, props.entry.id);
        });

        const setExpanded = (expanded) => {
            isExpanded.value = expanded;
        };

        return {
            pointerEventClass,
            mailMessageWrapper,
            iframe,
            isExpanded,
            setExpanded,
            iframeLoading,
        };
    },
};
</script>
